<template>
  <div id="app" class="container-fluid">
    <!-- Header (UNCHANGED) -->
    <full_oncology_head :visit_id="visit_id" />

    <!-- Main Content -->
    <div class="main-content">
      <div class="card investigations-card">
        <div class="investigations-header">
          <div class="header-left">
            <i class="fas fa-x-ray header-icon"></i>
            <div>
              <h3>Investigations</h3>
              <small class="text-muted">
                Radiology tests for this patient
              </small>
            </div>
          </div>

          <button
            class="btn btn-outline-primary"
            @click="showCreatePatientService"
          >
            <i class="fas fa-plus"></i> Add Scan
          </button>
        </div>

        <div v-if="loading">
          <loader />
        </div>

        <div v-if="!loading" class="card-body">
          <div class="table-responsive">
            <table class="table investigations-table">
              <thead>
                <tr>
                  <th scope="col">Scan Number</th>
                  <th scope="col">Scan Description</th>
                  <th scope="col">Status</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="service in services" :key="service.id">
                  <th scope="row">{{ service.id }}</th>
                  <td style="color: black">{{ service.service_name }}</td>
                  <td>
                    {{
                      service.attended == "0" || service.attended == null
                        ? "Pending..."
                        : service.attended == "1"
                        ? "Attended"
                        : "--"
                    }}
                  </td>
                  <td class="text-end">
                    <span
                      v-if="
                        open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior
                        )
                      "
                    >
                      <button
                        @click="handleShowAddScanModal(service.id)"
                        v-if="service.attended != 1"
                      >
                        Conduct
                      </button>
                      .
                    </span>

                    <span
                      v-if="
                        !open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior
                        )
                      "
                      style="
                        color: black;
                        background-color: pink;
                        padding: 1px;
                        margin: 2px;
                      "
                    >
                      !! Pending Payment !!
                    </span>

                    <button
                      @click="removeScan(service.id)"
                      v-if="service.attended != 1"
                    >
                      Remove/Delete Scan
                    </button>
                    .
                    <button
                      v-if="service.attended == 1"
                      @click="triggerShowResultModal(service.id)"
                    >
                      View
                    </button>
                  </td>
                </tr>
                <!-- <tr v-for="service in services" :key="service.id">
                  <th scope="row">{{ service.id }}</th>
                  <td style="color: black">{{ service.service_name }}</td>
                  <td>
                    <span
                      v-if="service.attended == '0' || service.attended == null"
                      >Pending...</span
                    >
                    <span
                      v-if="service.attended == '1' || service.attended == 1"
                      >Ongoing...</span
                    >
                    <span
                      v-if="service.attended == '2' || service.attended == 2"
                      >Completed</span
                    >
                  </td>
                  <td class="text-end">
                    <a
                      v-if="
                        open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior
                        )
                      "
                      :href="'/lab-details/' + service.id"
                      class="btn btn-sm btn-info button-touch"
                    >
                      Details</a
                    >.
                    <span
                      v-if="
                        !open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior
                        )
                      "
                      style="
                        color: black;
                        background-color: pink;
                        padding: 1px;
                        margin: 2px;
                      "
                    >
                      !! Pending Payment !!
                    </span>
                    <button
                      class="btn btn-sm btn-danger button-touch"
                      v-if="service.attended != 1"
                      @click="removeTest(service.id)"
                    >
                      Delete Test
                    </button>
                  </td>
                </tr> -->
                <!-- ====================================== -->

                <tr v-if="services.length === 0">
                  <td colspan="6" class="text-center text-muted py-4">
                    No investigations ordered for this patient
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AddRadiologyModal
    v-if="show_add_radiology_modal"
    @hide-create-rad-model="hideCreateScanModal"
    :service_id="current_scan"
  />

  <CreateServiceModal
    v-if="showAddServiceModal"
    :visitId="visit_id"
    @close-add-service-modal="showAddServiceModal = false"
  />
  <view_rad_result_modal
    v-if="showResultModal"
    :service_id="current_scan"
    @hide-view-result-modal="showResultModal = false"
  />
</template>

<script>
import AddRadiologyModal from "../../visits_management/radiology/add_radiology_modal.vue";
import CreateServiceModal from "../../visits_management/add_patient_service_modal.vue";
import view_rad_result_modal from "../../visits_management/radiology/view_rad_result_modal.vue";
import { generalApiRequest } from "../../../api/apiIndex.js";
import { get_setting } from "../../../settings/get_setting.js";
import loader from "../dialysis/loader.vue";
import { open_service } from "../../../settings/get_setting.js";

import full_oncology_head from "./full_oncology_head.vue";

export default {
  name: "PatientInvestigations",
  components: {
    full_oncology_head,
    CreateServiceModal,
    loader,

    AddRadiologyModal,
    view_rad_result_modal,
  },
  data() {
    return {
      visit_id: this.$route.params.visit_id,

      show_add_lab_test_modal: false,
      patient_id: null,
      showAddServiceModal: false,
      services: [],
      current_test: "",
      showViewModal: false,
      cash_bills_behavior: 0,
      loading: false,

      showResultModal: false,
      show_add_radiology_modal: false,
      current_scan: "",
    };
  },
  methods: {
    open_service,
    navigate_loc(route) {
      window.location.href = route;
    },

    handleShowAddScanModal(tid) {
      this.current_scan = tid;
      this.show_add_radiology_modal = true;
    },
    triggerShowResultModal(tid) {
      this.current_scan = tid;
      this.showResultModal = true;
    },

    hideCreateScanModal() {
      this.show_add_radiology_modal = false;
    },

    showCreatePatientService() {
      this.showAddServiceModal = true;
    },

    async fetchServicesForVisit() {
      this.loading = true;
      const url = `services/for-visit/${this.visit_id}` + "/3";
      try {
        const response = await generalApiRequest(url, "GET", {}, 1);
        console.log(response);

        this.services = response.data;
        const payment_setting = await get_setting("cash_bills_behavior");
        this.cash_bills_behavior = payment_setting.setting_value;
      } catch (error) {
        console.error("Error fetching services:", error);
      }
      this.loading = false;
    },

    async removeScan(serviceId) {
      const url = "services/delete/" + serviceId;
      const res = await generalApiRequest(url, "GET", {}, 1);
      if (res) {
        location.reload();
      }
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const res = await generalApiRequest(
        url,
        "GET",
        { visit_id: this.visit_id },
        1
      );
      this.past_records = res.data;
      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },
  },
  mounted() {
    this.mountPastRecords();
    this.fetchServicesForVisit();
  },
};
</script>

<style scoped>
/* Card */
.investigations-card {
  margin-top: 20px;
  border-radius: 8px;
  border-left: 5px solid #0d6efd;
  border-top: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

/* Header */
.investigations-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #dee2e6;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon {
  font-size: 26px;
  color: #0d6efd;
}

/* Table */
.investigations-table {
  font-size: 0.95rem;
}

.investigations-table thead th {
  background: #fafbfc;
  font-weight: 600;
  color: #495057;
}

/* Type pills */
.type-pill {
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.75rem;
  font-weight: 600;
}

.type-lab {
  background: #e7f1ff;
  color: #0d6efd;
}

.type-xray {
  background: #f1f3f5;
  color: #495057;
}

.type-ct {
  background: #fff3cd;
  color: #856404;
}

.type-mri {
  background: #e2e3f3;
  color: #3f51b5;
}

/* Status dots */
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot-ordered {
  background: #6c757d;
}

.dot-sample {
  background: #fd7e14;
}

.dot-reported {
  background: #0d6efd;
}

.dot-reviewed {
  background: #198754;
}

.status-text {
  font-size: 0.85rem;
}

/* Buttons */
.btn-light {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
}

.btn-light:hover {
  background: #e9ecef;
}

/* Responsive */
@media (max-width: 768px) {
  .investigations-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>
